import { render, staticRenderFns } from "./NewShopWeb.vue?vue&type=template&id=cf68763c&scoped=true&"
import script from "./NewShopWeb.vue?vue&type=script&lang=js&"
export * from "./NewShopWeb.vue?vue&type=script&lang=js&"
import style0 from "./NewShopWeb.vue?vue&type=style&index=0&id=cf68763c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf68763c",
  null
  
)

export default component.exports